<template>
  <q-btn
    icon="fa fa-times"
    title="Delete Report"
    v-bind="$attrs"
    @click="openModal"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Report } from '@/type';
import openModal from '@/components/modal';
import DeleteReportModal from './DeleteReportModal.vue';

export default defineComponent({
  emits: ['deleted'],
  props: {
    report: {
      type: Object as () => Report,
      required: true,
    },
  },
  methods: {
    openModal() {
      const props = { report: this.report, parent: this };
      openModal(DeleteReportModal, props).onOk(() => {
        this.$emit('deleted', this.report);
      });
    },
  },
});
</script>
